// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 14.2136L12.0159 14.2026C12.4403 13.9101 12.8621 13.6195 13.2604 13.2917C13.6614 12.9617 14.1981 12.484 14.738 11.8935C15.7821 10.7515 17 9.01233 17 7C17 4.23858 14.7614 2 12 2C9.23858 2 7 4.23858 7 7C7 9.01215 8.2179 10.7514 9.26196 11.8934C9.80183 12.4839 10.3386 12.9616 10.7395 13.2916C11.1379 13.6194 11.5596 13.9101 11.984 14.2026L12 14.2136ZM13.5 7C13.5 7.82843 12.8284 8.5 12 8.5C11.1716 8.5 10.5 7.82843 10.5 7C10.5 6.17157 11.1716 5.5 12 5.5C12.8284 5.5 13.5 6.17157 13.5 7Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 10H2V21.4978L8.92609 18.6097L14.9996 22.1579L22 18.0744V10H17V12H20V16.9256L15.0004 19.8421L9.0753 16.3806L4 18.4969V12H7V10Z"}}]};

const MapInformation1FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'map-information-1-filled',
    ref,
    icon: element,
  },
));

MapInformation1FilledIcon.displayName = 'MapInformation1FilledIcon';

export default MapInformation1FilledIcon;
